import I18n from 'I18n';
import { CONTENT_INLINE_MARGIN, CONTENT_MARGIN_BOTTOM } from '../../constants/styling';
import { TemplatePair } from './TemplatePair';
import { CategoryHeader } from './CategoryHeader';
import { useRef, useMemo, useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useWidthObserver } from '../../hooks/useWidthObserver';
// @ts-expect-error Untyped import
import { subAppKeysByTemplateKey } from 'sales-analytics-lib/utils/get-report-config';
import { groupTemplatesIntoPairs } from '../../utils/categoryUtils';
import { useTemplateNavigation } from '../../hooks/useTemplateNavigation';
import { Carousel } from 'foundations-components/transitional/components/Carousel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Category = ({
  id,
  labelKey,
  templates,
  tooltipKey
}) => {
  const containerRef = useRef(null);
  const containerWidth = useWidthObserver(containerRef);
  const {
    navigateToTemplate
  } = useTemplateNavigation();
  const handleTemplateClick = useCallback(template => {
    //TODO: Track event
    const subAppKey = subAppKeysByTemplateKey.get(template.get('templateKey'));
    navigateToTemplate(subAppKey);
  }, [navigateToTemplate]);
  const shouldGroupIntoPairs = containerWidth > 800;
  const templateList = useMemo(() => shouldGroupIntoPairs ? groupTemplatesIntoPairs(templates) : templates.map(template => [template]), [templates, shouldGroupIntoPairs]);
  const showCarousel = templateList.length > 1;
  const singlePairs = !shouldGroupIntoPairs;
  return /*#__PURE__*/_jsx(View, {
    ref: containerRef,
    inlineSize: "100%",
    marginBlockEnd: CONTENT_MARGIN_BOTTOM,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(CategoryHeader, {
        id: id,
        labelKey: labelKey,
        seeAll: showCarousel,
        tooltipKey: tooltipKey
      }), showCarousel ? /*#__PURE__*/_jsx(Carousel, {
        padding: "0",
        maxWidth: "100%",
        "data-test-id": "category-carousel",
        steps: templateList.map(templatePair => ({
          content: /*#__PURE__*/_jsx(TemplatePair, {
            templates: templatePair,
            singlePairs: singlePairs,
            onTemplateClick: handleTemplateClick
          }),
          alt: I18n.text('smartLibrary.analyticsSuite.categories.templates', {
            category: I18n.text(labelKey)
          })
        }))
      }) : /*#__PURE__*/_jsx(View, {
        marginInline: CONTENT_INLINE_MARGIN,
        children: /*#__PURE__*/_jsx(TemplatePair, {
          templates: templateList[0],
          singlePairs: singlePairs,
          onTemplateClick: handleTemplateClick
        })
      })]
    })
  });
};